
import './Banner.css'; // Place CSS in a separate file or use styled-components
import { useNavigate } from "react-router-dom";

export default function Banner(){

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/courses"); // navigate to /courses
  };
    return(
   <>
   <section className="bg-gray-50 px-6 py-12" style={{ backgroundColor: 'rgb(219 228 220 / 23%)' }}>
  <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
    
   
    <div className="md:w-1/2 text-center md:text-left space-y-4">

  <h2 className="text-4xl font-extrabold text-gray-900 leading-tight">
    Achieve your career goals with <br />
    <span className="text-blue-700" style={{ color: 'rgb(93, 76, 207)' }}>Executive Development Center</span>
  </h2>

  <p className="text-gray-700 text-base text-justify">
    Executive Development Center typically refers to an executive development program and courses. These programs are designed to enhance the skills, knowledge, and capabilities of executives and senior managers in logistics business leadership.EDC Executive Development Center is the flagship Logistics Learning Portal from Logistics Sector Skill Council
      the apex skill providing Sector Skill Council - part of Government of India. These programs are designed to enhance the skills, knowledge, and capabilities of executives and senior managers in logistics business leadership.
  </p>

  <p className="text-blue-700 text-lg italic font-semibold" style={{ color: 'rgb(93, 76, 207)' }}>
  "Enroll anytime and learn at your convenience."
</p>
  
  <button
      onClick={handleClick}
      className="hover:bg-blue-800 text-white font-semibold text-sm px-6 py-3 rounded-md shadow-md"
      style={{ backgroundColor: "rgb(93, 76, 207)" }}
    >
      View All courses
    </button>


  {/* <p className="text-sm text-blue-700 font-semibold">
    or ₹34,275/year with 14-day money-back guarantee
  </p> */}
</div>


 
    <div className="md:w-1/2 flex justify-center md:justify-end">
  <img 
    src="/images/home.webp"
    alt="Enhance Potential"
    className="
      w-full 
      max-w-xs 
      sm:max-w-sm 
      md:max-w-md 
      object-contain 
      rounded-2xl 
      mx-auto
    "
  />
</div>


  </div>
</section>
   </>

    )
}